import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broker-pass',
  templateUrl: './broker-pass.component.html',
  styleUrls: ['./broker-pass.component.scss']
})
export class BrokerPassComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
